import './Desafios.css';
import imagem from "./img/Desafios.png";

function Desafios() {
  return (
    <div id="Desafios" className="DesafiosContainer">
        <div className="DesafiosLeft">
          <div className="DesafiosLeftTitle">
              + Desafios
          </div>
          <div className="DesafiosLeftTitle">
              + Grana no bolso
          </div>
          <div className="DesafiosLeftText" style={{marginTop: "25px"}}>
              Distribuímos atividades a partir da relação com as empresas parceiras. Estas atividades, nomeadas de Desafios, são apresentadas conforme sua localização, ou seja, sempre terá alguma próxima a você. 
          </div>
          <div className="DesafiosLeftText">
              E para que consiga, criamos treinamentos exclusivos que explicam no detalhe tudo que precisa ser feito. Assim qualquer usuário poderá fazer.
          </div>
        </div>
        <div className="DesafiosRight">
            <img width="100%" src={imagem} alt="Desafios" />
        </div>
    </div>
  );
}

export default Desafios;
